import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RulesGeneratorModeration',

  mixins: [ proxy({ type: 'string' }) ],

  render
}
